import React, { useState, useEffect } from 'react';
import './contactPage.css';
import {useNavigate} from "react-router-dom";

const ContactPage = () => {
    const navigate = useNavigate()
    const [weatherInfo, setWeatherInfo] = useState('날씨 정보 로딩 중...');
    const [locationInfo, setLocationInfo] = useState('위치 정보 로딩 중...');
    const [message, setMessage] = useState('');
    const [locationData, setLocationData] = useState({
        ip: '',
        location: ''
    });
    const [progress, setProgress] = useState({
        show: false,
        percentage: 0,
        text: ''
    });

    const getWeather = async (lat, lon) => {
        try {
            const response = await fetch(`http://js94.kro.kr:4000/api/weather?lat=${lat}&lon=${lon}`);
            const data = await response.json();
            const weatherInfoText = `
                접속지역: ${data.location.name}, ${data.location.region}<br>
                온도: ${data.current.temp_c}°C / ${data.current.temp_f}°F<br>
                날씨:${data.current.condition.text}
            `;
            setWeatherInfo(weatherInfoText);
        } catch (error) {
            console.error('Weather API 요청 실패:', error);
            setWeatherInfo('날씨 정보 로드 실패');
        }
    };

    const getLocation = async () => {
        try {
            const response = await fetch(`https://ipinfo.io/json?token=${process.env.REACT_APP_IPINFO_API_KEY}`);
            const data = await response.json();
            const [lat, lon] = data.loc.split(',');

            setLocationData({
                ip: data.ip,
                location: `위도: ${lat}, 경도: ${lon}`
            });
            setLocationInfo(`위도: ${lat}, 경도: ${lon}`);

            await getWeather(lat, lon);
        } catch (error) {
            console.error('IP 정보 요청 실패:', error);
            setLocationInfo('위치 정보 로드 실패');
        }
    };

    const updateProgressBar = (percentage, text) => {
        setProgress({
            show: true,
            percentage,
            text
        });
    };

    const sendData = async () => {
        const data = {
            message: message,
            location: locationData.location,
            locationIp: locationData.ip,
            sendDate: new Date().toISOString().split('T')[0],
            sendTime: new Date().toISOString().split('T')[1].split('.')[0],
            chatId: "onlyPage"
        };

        updateProgressBar(0, '전송 준비 중...');

        try {
            const response = await fetch('https://proxy.cors.sh/http://js94.kro.kr:4000/api/mail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-cors-api-key': 'temp_9f0154e45f98b4ac40ac64627697397b'
                },
                body: JSON.stringify(data)
            });

            updateProgressBar(50, '메일 전송 중...');
            const responseData = await response.json();
            updateProgressBar(100, '메일 전송 완료!');
            console.log('Success:', responseData);
            alert('메일 전송 성공!');
        } catch (error) {
            console.error('Error:', error);
            updateProgressBar(100, '메일 전송 실패.');
            alert('데이터 전송 실패.');
        } finally {
            setTimeout(() => {
                setProgress(prev => ({ ...prev, show: false }));
            }, 2000);
        }
    };

    useEffect(() => {
        getLocation();
    }, []);

    return (
        <div className="container">
            <h1>안녕하세요, SALCHO 입니다!</h1>
            <p> 문의하실 내용을 적어주세요 (개선사항 포함)</p>

            <div
                className="weather-info"
                dangerouslySetInnerHTML={{ __html: weatherInfo }}
            />
            <div className="location-info">{locationInfo}</div>

            <input type="hidden" value={locationData.ip} />
            <input type="hidden" value={locationData.location} />

            {progress.show && (
                <div className="progress-container">
                    <div
                        className="progress-bar"
                        style={{ width: `${progress.percentage}%` }}
                    />
                    <div className="progress-text">{progress.text}</div>
                </div>
            )}

            <div className="form-group">
                <label htmlFor="message">내용</label>
                <textarea
                    id="message"
                    rows="4"
                    placeholder="내용을 입력하세요..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />
            </div>
            <button className="btn btn-success button float-end m-1" onClick={sendData}>
                전송
            </button>
            <button className="btn btn-danger button float-end m-1" onClick={() =>navigate('/luckyDetail',{replace:true})}>
                취소
            </button>

           
        </div>
    );
};

export default ContactPage;